module.exports = __webpack_public_path__ + "img/tp3.e62f7c5b.png";